import { useCallback } from "react";
import { useDispatch } from "react-redux";

import { setLevel, setMessage, setOpen } from "../redux/alertSlice";

export default function useToastAlert() {
	const dispatch = useDispatch();

	const handleToastAlert = useCallback((level: string, message: string) => {
		dispatch(setOpen(true));
		dispatch(setLevel(level));
		dispatch(setMessage(message));
	}, [dispatch]);

	return { handleToastAlert };
}
